import script from "./Process.vue?vue&type=script&setup=true&lang=js"
export * from "./Process.vue?vue&type=script&setup=true&lang=js"

import "./Process.vue?vue&type=style&index=0&id=fd287b82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd287b82"]])

export default __exports__